<template>
    <div ref="viewer"
         class="wh-full viewer">
        <div v-if="loading"
             class="viewer__loading">
            Загрузка модели...
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'

import { load, create } from '@/backends/autopilotViewer'

export default {
  name: 'BimViewer',
  props: {
    viewMode: {
      type: Boolean,
      default: false
    },
    planId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('bimViewer', ['selectedUrl', 'selectedOldUrl'])
  },
  watch: {
  },
  beforeDestroy() {
    this.destroyed = true
    this.viewer?.dispose()
  },
  mounted () {
    const url = this.selectedUrl

    console.log(url)

    if (this.selectedOldUrl) {
      dialogs.error.call(this, { message: 'Данный тип файла больше не поддерживается', duration: 1000 })
      return
    }

    if(!url) {
      dialogs.error.call(this, { message: 'Ссылка на BIM модель не найдена', duration: 1000 })
      return
    }

    this.loading = true

    load()
      .then(() => {
        if (this.destroyed) return
        // Not in data(): Vue must not make the viewer reactive.
        this.viewer = create(this.$refs.viewer)
        return this.viewer.load(url)
      })
      .then(() => this.loading = false)
      .catch((error) => {
        if (error.name === 'AbortError') return
        this.loading = false
        dialogs.error.call(this, { message: 'Не удалось загрузить BIM модель' })
      })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.viewer {
  position: relative;
  margin: auto;

  &__loading {
    // Under the viewer, which covers it with its own progress once created.
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    text-align: center;
    color: #fff;
    line-height: 50;
  }
}

.photo-joystick {
  position: absolute;
  left: 1.5rem;
  bottom: 1.5rem;
  z-index: 99;
}
.bar {
  position: absolute;
  z-index: 999;
  background: #ffffffa1
}
</style>
